<template>
  <div class="playback-time">
    <div class="aisea-text-20-400-white">
      {{ now }}
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "PlaybackTime",
  props: ["nowTime"],
  watch: {
    nowTime(v) {
      this.value = v;
    },
  },
  computed: {
    now() {
      return this.toJST();
    },
  },
  methods: {
    toJST() {
      return moment.unix(this.nowTime).format("YYYY/MM/DD HH:mm:ss");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
</style>
